__turbopack_context__.v({
  "quickFilter": "RestaurantHomeFilters-module-sass-module__zUeRWa__quickFilter",
  "quickFilterTitle": "RestaurantHomeFilters-module-sass-module__zUeRWa__quickFilterTitle",
  "wrapper": "RestaurantHomeFilters-module-sass-module__zUeRWa__wrapper",
});
